module.exports = __webpack_public_path__ + "img/sound-1-image.b9b56545.svg";